import { render } from "./ProfileUserMenuMobile.vue?vue&type=template&id=5c38bf60"
import script from "./ProfileUserMenuMobile.vue?vue&type=script&lang=js"
export * from "./ProfileUserMenuMobile.vue?vue&type=script&lang=js"

import "./ProfileUserMenuMobile.vue?vue&type=style&index=0&id=5c38bf60&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__